module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {}, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', {
    attrs: {
      "title": _vm.proposta.ds_codigo_projeto_erp + ' - ' + _vm.proposta.ds_nome
    }
  }, [_vm._v("\n        Emissão de Documentos: Projeto " + _vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome) + "\n      ")])]), _vm._v(" "), (!_vm.loading) ? _c('section', {
    ref: "botoes",
    staticClass: "content"
  }, [(this.$root.isFundacao(this.usuarioLogado) && this.loading === false) ? _c('div', {
    staticClass: "row"
  }, [_c('b-card', {
    staticClass: "col-md-6",
    staticStyle: {
      "max-width": "25%"
    }
  }, [_c('div', {
    staticClass: "botaoGerarArquivo",
    attrs: {
      "id": "atestado"
    },
    on: {
      "click": function($event) {
        return _vm.botaoDocumento($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "atestado",
      "width": "40",
      "height": "60",
      "src": require("../../../static/img/iconeWord.png")
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "atestado"
    }
  }, [_vm._v("Atestado de Capacidade Técnica")])]), _vm._v(" "), _c('div', {
    staticClass: "botaoGerarArquivo",
    attrs: {
      "id": "notificacaoAviso"
    },
    on: {
      "click": function($event) {
        return _vm.botaoDocumento($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "notificacaoAviso",
      "width": "40",
      "height": "60",
      "src": require("../../../static/img/iconeWord.png")
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "notificacaoAviso"
    }
  }, [_vm._v("Notificação Extrajudicial - Aviso")])]), _vm._v(" "), _c('div', {
    staticClass: "botaoGerarArquivo",
    attrs: {
      "id": "notificacaoFinal"
    },
    on: {
      "click": function($event) {
        return _vm.botaoDocumento($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "notificacaoFinal",
      "width": "40",
      "height": "60",
      "src": require("../../../static/img/iconeWord.png")
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "notificacaoFinal"
    }
  }, [_vm._v("Notificação Extrajudicial - Final")])]), _vm._v(" "), _c('div', {
    staticClass: "botaoGerarArquivo",
    attrs: {
      "id": "relatorioMonitoramento"
    },
    on: {
      "click": function($event) {
        return _vm.botaoDocumento($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "relatorioMonitoramento",
      "width": "40",
      "height": "60",
      "src": require("../../../static/img/iconeWord.png")
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "relatorioMonitoramento"
    }
  }, [_vm._v("Relatório de Monitoramento Presencial")])]), _vm._v(" "), _c('div', {
    staticClass: "botaoGerarArquivo",
    attrs: {
      "id": "briefing"
    },
    on: {
      "click": function($event) {
        return _vm.botaoDocumento($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "briefing",
      "width": "40",
      "height": "60",
      "src": require("../../../static/img/iconeWord.png")
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "briefing"
    }
  }, [_vm._v("Briefing")])])]), _vm._v(" "), (this.briefing) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Dados que devem constar no Briefing")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-block"
  }, [_c('b-form-checkbox-group', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.dadosBriefing,
      "value-field": "id",
      "text-field": "nome",
      "stacked": ""
    },
    model: {
      value: (_vm.selecionadosBriefing),
      callback: function($$v) {
        _vm.selecionadosBriefing = $$v
      },
      expression: "selecionadosBriefing"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "briefing"
    },
    on: {
      "click": _vm.gerarBriefing
    }
  }, [_vm._v("Gerar arquivo de Briefing\n            ")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6da1ca9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/EmissaoDocumentos.vue
// module id = 1938
// module chunks = 2